// 导入API基础类

/**
 * 特派员信息管理模块API
 */
export default class TechPersonnelController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/techPersonnel/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/techPersonnel/view', 'get', params, axiosOption, httpOption);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/techPersonnel/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/techPersonnel/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/techPersonnel/delete', 'post', params, axiosOption, httpOption);
  }

  static importData (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/techPersonnel/import', 'post', params, axiosOption, httpOption);
  }

  static getStats (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/techPersonnel/stats', 'get', params, axiosOption, httpOption);
  }

  static getAllStats (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/techPersonnel/stats/all', 'get', params, axiosOption, httpOption);
  }
};
